import React, { useEffect } from 'react';
import { Editor as MonacoEditor } from '@monaco-editor/react';
import { useSelector } from 'react-redux';

import styles from '../../components/Editor/Editor.scss';
import { useDispatch } from 'react-redux';
import Header from '../../components/Editor/Header';
import Footer from '../../components/Editor/Footer';

const mode = {
  python3: 'python',
  javascript: 'javascript',
  c: 'c',
  cpp: 'cpp',
  java: 'java',
  ruby3: 'ruby',
};

function InterviewEditor(props) {
  console.log('Rendering InterviewEditor code:', props.code);
  const { theme, currentLanguageforProblems } = useSelector(state => state.events.theme);
  const dispatch = useDispatch();
  const toggleTheme = checked => {
    dispatch({ type: 'SET_THEME', payload: checked ? 'vs-dark' : 'vs' });
  };

  const codeReset = () => {
    console.log('Resetting code to template body:', props.activeTemplate?.body);
    props.updateCode(props.activeTemplate?.body.trim() || '');
  };

  return (
    <div
      className={styles['c-editor']}
      data-testid="code-editor-container"
      style={{
        backgroundColor: theme === 'vs-dark' ? '#1e1e1e' : '#fff',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header
        selectedLanguage={props.selectedLanguage}
        editorExpand={props.editorExpand}
        languageList={props.templates.map(template => template.language)}
        switchLanguage={props.switchLanguage}
        toggleExpand={props.toggleExpand}
        codeReset={codeReset}
        theme={theme}
        toggleTheme={toggleTheme}
        activeTemplate={props.activeTemplate}
        onDriverCodeModalToggle={props.onDriverCodeModalToggle}
      />
      <div
        className={styles['c-editor__ace']}
        style={{ flex: 1, minHeight: 0 }}
      >
        {props.code && (
          <MonacoEditor
            language={mode[props.lang]}
            theme={theme}
            onChange={code => props.updateCode(code)}
            options={{
              highlightActiveLine: false,
              showPrintMargin: false,
              dragAndDrop: false,
              tabSize: 4,
              scrollBeyondLastLine: false,
              renderFinalNewline: false,
              minimap: {
                enabled: false,
              },
            }}
            value={props.code}
            height="100%"
          />
        )}
      </div>
      <div>{props.code}</div>
      <Footer
        submitCode={props.submitCode}
        disabled={props.disabled}
        codeReset={codeReset}
        theme={theme}
      />
    </div>
  );
}

export default InterviewEditor;
